import { ReactElement } from 'react'
import { ExtendedRefinementListItem, RangeRefinementConfig } from '../types'

type RefinementWrapperProps<
  T extends ExtendedRefinementListItem | RangeRefinementConfig,
> = {
  refinement: T
  Component: React.ComponentType<Omit<T, 'isHidden'>>
}

export function RefinementWrapper<
  T extends ExtendedRefinementListItem | RangeRefinementConfig,
>({ refinement, Component }: RefinementWrapperProps<T>): ReactElement {
  const { isHidden, ...props } = refinement
  const content = <Component {...props} />

  return isHidden ? (
    // We should render the component not to lose state, but hide it from the interface
    <div key={`wrapper-${refinement.attribute}`} className="hidden">
      {content}
    </div>
  ) : (
    content
  )
}
